// extracted by mini-css-extract-plugin
export default {"mySwiper":"ProductImageSlider_mySwiper__g07gm"};